import SvgIcon from '@mui/material/SvgIcon'
import Typography from '@mui/material/Typography'
import MemberIcon from 'assets/tiers/Member.svg?react'
import VipIcon from 'assets/tiers/VIP.svg?react'
import EliteIcon from 'assets/tiers/Elite.svg?react'
import InsiderIcon from 'assets/tiers/Insider.svg?react'
import { type ElementType } from 'react'

const resolveIconComponent = (iconSource: unknown): ElementType => {
  if (iconSource && typeof iconSource === 'object' && 'default' in iconSource) {
    return (iconSource as { default: ElementType }).default
  }

  return iconSource as ElementType
}

export const PatronTierSubtitle = ({
  patronTier,
}: {
  patronTier: string | undefined
}) => {
  const MemberIconComponent = resolveIconComponent(MemberIcon)
  const InsiderIconComponent = resolveIconComponent(InsiderIcon)
  const EliteIconComponent = resolveIconComponent(EliteIcon)
  const VipIconComponent = resolveIconComponent(VipIcon)

  return (
    <>
      <Typography
        sx={{
          fontWeight: 'bold',
        }}
        color={'text.primary'}
        variant="body-3"
        className="whitespace-pre-line"
      >
        {patronTier}
      </Typography>

      {patronTier && patronTier === 'Member' && (
        <SvgIcon
          sx={{
            transform: 'translate(0px,-3px)',
            marginLeft: '7px',
            marginRight: '11px',
          }}
        >
          {MemberIconComponent ? <MemberIconComponent /> : null}
        </SvgIcon>
      )}
      {patronTier && patronTier === 'Insider' && (
        <SvgIcon
          sx={{
            marginLeft: '10px',
            marginRight: '15px',
          }}
        >
          {InsiderIconComponent ? <InsiderIconComponent /> : null}
        </SvgIcon>
      )}
      {patronTier && patronTier === 'Elite' && (
        <SvgIcon
          sx={{
            transform: 'translate(0px,-3px)',
            marginLeft: '8px',
            marginRight: '11px',
          }}
        >
          {EliteIconComponent ? <EliteIconComponent /> : null}
        </SvgIcon>
      )}
      {patronTier && patronTier === 'VIP' && (
        <SvgIcon
          sx={{
            transform: 'translate(0px,-2px)',
            marginLeft: '8px',
            marginRight: '11px',
          }}
        >
          {VipIconComponent ? <VipIconComponent /> : null}
        </SvgIcon>
      )}
    </>
  )
}
